export default __webpack_public_path__ + "static/media/grid-light.f002695c.svg";